// src/pages/OtpPage.jsx
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { AuthContext } from "../context/AuthContext"; // ★  use the context
import { encryptData } from "../utils/crypto";
import { API_URL } from '../config/api';
import BRANDING from "../config/branding";

const OtpPage = () => {
	const navigate = useNavigate();
	const { login } = useContext(AuthContext); // ★  get the login helper

	const [otp, setOtp] = useState("");
	const [loading, setLoading] = useState(false);
	const email = localStorage.getItem("email"); // e‑mail was saved during step‑1 login

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		const tempToken = sessionStorage.getItem("token"); // token issued in step‑1 login

		try {
			const { data } = await axios.post(
				`${API_URL}/otp.php`,
				{ otp },
				{
					headers: { Authorization: `Bearer ${tempToken}` },
					// withCredentials: true,
				}
			);

			if (data.status) {
				const encryptedRole = encryptData(data.role); // ⬅️ encrypt the role
				login(data.token, encryptedRole, email); // ⬅️ pass encrypted role

				toast.success("OTP verified!");
				navigate("/dashboard");
			} else {
				// API returned status:false
				const msg = data.message || "Invalid OTP.";
				toast.error(msg);
				localStorage.clear();
				sessionStorage.clear();
				navigate("/");

				if (msg.toLowerCase().includes("otp has expired")) {
					toast.info("Your OTP has expired. Please log in again.");
					/* clean up temp data */
					localStorage.removeItem("email");
					sessionStorage.removeItem("token");
					navigate("/");
				}
			}
		} catch (err) {
			console.error("OTP verification error:", err);
			toast.error("Verification failed. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	/* -------------------------------------------------------------- */
	/*  Guard: if already logged in (token in localStorage)           */
	/* -------------------------------------------------------------- */
	useEffect(() => {
		if (localStorage.getItem("token")) {
			navigate("/dashboard", { replace: true });
		}
		if (!email) {
			navigate("/", { replace: true });
		}
	}, [navigate, email]);

	return (
		<div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-white font-inter'>
		<div className='flex justify-center mb-6'>
    <img
        src={BRANDING.logo}
        alt={BRANDING.shortName}
        className='h-20 w-auto object-contain'
    />
</div>
			<div className='bg-white p-10 rounded-2xl border border-slate-200 shadow-xl w-full max-w-md'>
	<h2
    className='text-3xl font-bold text-center mb-2'
    style={{ color: BRANDING.primaryColor }}
>
    Verify One-Time Password
</h2>

<p className='text-center text-slate-500 mb-6'>
    Complete your secure sign-in
</p>

				<form onSubmit={handleSubmit} className='space-y-6'>
					<p className='text-base text-gray-700 text-center'>
						A verification code has been sent to{" "}
						<strong style={{ color: BRANDING.primaryColor }}>{email || "your email"}</strong>.
						It will expire in 5&nbsp;minutes.
					</p>

					<div>
						<label htmlFor='otp' className='sr-only'>
							Enter OTP
						</label>
						<input
							id='otp'
							type='text'
							value={otp}
							onChange={(e) => setOtp(e.target.value)}
							placeholder='Enter OTP'
							className='
w-full
px-5
py-3
border
border-gray-300
rounded-lg
focus:outline-none
focus:ring-2
focus:ring-red-600
focus:border-red-600
transition
duration-200
text-lg
tracking-widest
text-center
font-semibold
'
							required
							maxLength='6'
							pattern='\d{6}'
							title='Please enter a 6‑digit OTP'
						/>
					</div>

					<button
						type='submit'
						disabled={loading}
						className='w-full py-3 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed'
					>
						{loading ? "Verifying…" : "Verify OTP"}
					</button>
				</form>
			</div>
		</div>
	);
};

export default OtpPage;
